<script setup lang="ts">
  // Idioma
  const { t } = useI18n()

  useSeoMeta({ robots: 'noindex, nofollow' })

  // Layout
  definePageMeta({
    layout: 'simple'
  })

  // Login redirect logic
  const { handleLoginSuccess } = useLoginRedirect()

</script>

<template>
  <div class="w-full p-10">
    <div class="max-w-sm mx-auto flex flex-col gap-10">
      
      <h1 class="text-4xl text-center">{{ t('labels.login.register.title') }}</h1>

      <RegisterForm 
        @register-success="() => handleLoginSuccess()"
      />

    </div>
  </div>
</template>